import { MS_PER_TICK } from "types/battle-engine/constants";

// Convert milliseconds to ticks, using MS_PER_TICK from battle-engine
export const msToTicks = (ms: number) => {
  return Math.ceil(ms / MS_PER_TICK);
};
